import StorageFileApi from './packages/StorageFileApi';
import StorageBucketApi from './packages/StorageBucketApi';
export class StorageClient extends StorageBucketApi {
  constructor(url) {
    let headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let fetch = arguments.length > 2 ? arguments[2] : undefined;
    super(url, headers, fetch);
  }
  /**
   * Perform file operation in a bucket.
   *
   * @param id The bucket id to operate on.
   */
  from(id) {
    return new StorageFileApi(this.url, this.headers, id, this.fetch);
  }
}